import { SearchTermAdapter } from "../ls/LSSearch";
import { AdvancedSearchTerm, isAdvancedSearchTerm } from "./AdvancedSearchTerm";

export const advancedSearchTermAdapter: SearchTermAdapter<AdvancedSearchTerm> =
  {
    getTerm: function (sp: URLSearchParams): AdvancedSearchTerm {
      try {
        const termParam = sp.get("term");
        if (!termParam) {
          return null;
        }

        const term = JSON.parse(termParam);
        if (isAdvancedSearchTerm(term)) {
          return term;
        }
        return null;
      } catch (e: unknown) {
        return null;
      }
    },
    toApiString: function (term: AdvancedSearchTerm): string {
      return JSON.stringify(term);
    },
    setTerm: function (
      sp: URLSearchParams,
      term: AdvancedSearchTerm
    ): URLSearchParams {
      sp.set("term", JSON.stringify(term));
      return sp;
    },
  };
